import { endpoints } from "../config/endpoints.js";
import initEvents from "../modules/events.js";

export default function initEventsFeed(root = document) {
  console.log("INIT Events Feed RUNNING");

  const modules = root.querySelectorAll("[data-module='events-feed']");
  if (!modules.length) return;

  modules.forEach(async (module) => {
    if (module.dataset.eventsFeedInitialised === "true") return;
    module.dataset.eventsFeedInitialised = "true";

    try {
      const res = await fetch(endpoints.eventsFeed, {
        cache: "no-store",
      });

      if (!res.ok) throw new Error("Failed to load events");

      const html = await res.text();

      if (!html.trim()) {
        module.innerHTML = "";
        return;
      }

      module.innerHTML = html;

      initEvents(module);

    } catch (err) {
      console.warn("Events feed failed:", err);
      module.innerHTML = "<p>Events are currently unavailable.</p>";
    }
  });
}